<template>
  <b-overlay :show="showOverlay" rounded="sm">
    <div>
      <b-card no-body class="mb-0">
        <div class="m-2">
          <b-row>
            <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start my-1 my-md-0"
            >
              <label>نمایش</label>
              <v-select
                  v-model="perPage"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>تعداد</label>
            </b-col>
            <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-end my-1 my-md-0"
            >
              <b-button variant="primary" @click="openCreateModal">
                <feather-icon icon="PlusIcon" class="mr-50" />
                افزودن سوال جدید
              </b-button>
            </b-col>
          </b-row>
        </div>

        <b-table
            ref="faqTable"
            class="position-relative"
            :items="faqList"
            responsive
            :fields="tableColumns"
            primary-key="faqId"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
        >
          <template #cell(edit)="data">
            <b-link class="text-primary" @click="openEditModal(data.item)">
              <feather-icon icon="EditIcon" size="20" />
            </b-link>
          </template>

          <template #cell(delete)="data">
            <b-link
                class="text-danger"
                v-b-modal.modal-delete
                @click="setDeleteFaqId(data.item.faqId)"
            >
              <feather-icon icon="TrashIcon" size="20" />
            </b-link>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            </b-col>
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalCount"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                      style="transform: rotate(180deg)"
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>

    <b-modal
        id="modal-faq"
        :title="modalTitle"
        centered
        ok-title="ذخیره"
        cancel-title="انصراف"
        @ok="saveFaq"
        @hidden="resetModal"
    >
      <b-form-group label="سوال:" label-for="question-input">
        <b-form-input
            id="question-input"
            v-model="form.question"
            required
            placeholder="متن سوال را وارد کنید"
        />
      </b-form-group>
      <b-form-group label="پاسخ:" label-for="answer-input">
        <b-form-textarea
            id="answer-input"
            v-model="form.answer"
            rows="4"
            placeholder="متن پاسخ را وارد کنید"
        />
      </b-form-group>
    </b-modal>

    <b-modal
        id="modal-delete"
        centered
        ok-title="حذف"
        cancel-title="انصراف"
        @ok="confirmDelete"
    >
      <span>آیا از حذف این سوال متداول اطمینان دارید؟</span>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BLink,
  BPagination,
  BOverlay,
  BModal,
  BButton,
  BFormGroup,
  BFormInput,
  BFormTextarea,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { getAllFaq, createFaq, updateFaq, deleteFaq } from '@/libs/Api/faq'

export default {
  name: 'FaqList',
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BLink,
    BPagination,
    BOverlay,
    BModal,
    BButton,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    vSelect,
  },
  data() {
    return {
      faqList: [],
      showOverlay: false,
      currentPage: 1,
      totalCount: null,
      perPage: 10,
      perPageOptions: [10, 20, 30, 40, 50],
      faqIdToDelete: null,
      form: {
        faqId: null,
        question: '',
        answer: '',
      },
      tableColumns: [
        { key: 'faqId', label: 'شناسه' },
        { key: 'question', label: 'سوال' },
        { key: 'answer', label: 'پاسخ' },
        { key: 'edit', label: '' },
        { key: 'delete', label: '' },
      ],
    }
  },
  computed: {
    modalTitle() {
      return this.form.faqId ? 'ویرایش سوال متداول' : 'افزودن سوال متداول'
    },
  },
  watch: {
    perPage() {
      this.currentPage = 1
      this.fetchFaqs()
    },
    currentPage() {
      this.fetchFaqs()
    },
    '$route.query.pageNumber': {
      handler(newPage) {
        const page = parseInt(newPage)
        if (!isNaN(page) && page !== this.currentPage) {
          this.currentPage = page
          this.fetchFaqs()
        }
      },
      immediate: false,
    },
  },
  created() {
    const initialPage = this.$route.query.pageNumber
        ? parseInt(this.$route.query.pageNumber)
        : 1
    this.currentPage = initialPage
    this.fetchFaqs()
  },
  methods: {
    fetchFaqs() {
      this.showOverlay = true
      const params = {
        pageNumber: this.currentPage,
        count: this.perPage,
      }

      const faqRequest = new getAllFaq(this)
      faqRequest.setParams(params)
      faqRequest.fetch(
          (response) => {
            this.showOverlay = false
            this.faqList = response.data || response.faqs || []
            this.totalCount = response.total || response.totalCount || 0
          },
          (error) => {
            this.showOverlay = false
            console.error('خطا در دریافت سوالات متداول:', error)
            this.showToast('خطا', 'مشکلی در بارگذاری اطلاعات رخ داد.', 'danger')
          }
      )
    },

    openCreateModal() {
      this.resetForm()
      this.$bvModal.show('modal-faq')
    },

    openEditModal(item) {
      this.form.faqId = item.faqId
      this.form.question = item.question
      this.form.answer = item.answer
      this.$bvModal.show('modal-faq')
    },

    saveFaq() {
      if (!this.form.question.trim()) {
        this.showToast('خطا', 'لطفاً متن سوال را وارد کنید.', 'danger')
        return
      }
      if (!this.form.answer.trim()) {
        this.showToast('خطا', 'لطفاً متن پاسخ را وارد کنید.', 'danger')
        return
      }

      this.showOverlay = true

      if (this.form.faqId) {
        const updateRequest = new updateFaq(this)
        updateRequest.setParams(this.form)
        updateRequest.fetch(
            () => {
              this.showOverlay = false
              this.showToast('عملیات موفق', 'سوال متداول با موفقیت ویرایش شد.', 'success')
              this.$bvModal.hide('modal-faq')
              this.fetchFaqs()
            },
            (error) => {
              this.showOverlay = false
              console.error('خطا در ویرایش:', error)
              this.showToast('خطا', 'ویرایش سوال انجام نشد.', 'danger')
            }
        )
      } else {
        const createRequest = new createFaq(this)
        createRequest.setParams(this.form)
        createRequest.fetch(
            () => {
              this.showOverlay = false
              this.showToast('عملیات موفق', 'سوال متداول با موفقیت ایجاد شد.', 'success')
              this.$bvModal.hide('modal-faq')
              this.fetchFaqs()
            },
            (error) => {
              this.showOverlay = false
              console.error('خطا در ایجاد:', error)
              this.showToast('خطا', 'ایجاد سوال انجام نشد.', 'danger')
            }
        )
      }
    },

    setDeleteFaqId(faqId) {
      this.faqIdToDelete = faqId
    },

    confirmDelete() {
      if (!this.faqIdToDelete) return
      this.showOverlay = true

      const deleteRequest = new deleteFaq(this)
      deleteRequest.setId(this.faqIdToDelete)
      deleteRequest.fetch(
          () => {
            this.showOverlay = false
            this.showToast('عملیات موفق', 'سوال متداول با موفقیت حذف شد.', 'success')
            this.$bvModal.hide('modal-delete')
            this.faqIdToDelete = null
            this.fetchFaqs()
          },
          (error) => {
            this.showOverlay = false
            console.error('خطا در حذف:', error)
            this.showToast('خطا', 'حذف سوال انجام نشد.', 'danger')
            this.faqIdToDelete = null
          }
      )
    },

    resetModal() {
      this.resetForm()
    },

    resetForm() {
      this.form = {
        faqId: null,
        question: '',
        answer: '',
      }
    },

    showToast(title, text, variant) {
      this.$toast({
        component: ToastificationContent,
        position: 'bottom-center',
        props: {
          title,
          icon: variant === 'success' ? 'CheckIcon' : 'XIcon',
          variant,
          text,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>